import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { BottomSheetContentLayout, TextField, useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { TriageFieldBox } from '../TriageFieldBox/TriageFieldBox';
import { TriageRow } from '../TriageRow/TriageRow';
import s from './TriageAgreementNameRow.module.scss';
export const GetTriageAgreementNameRowTID = (parentTestId)=>getTestIds(parentTestId);
export const AgreementNameRowTestIds = GetTriageAgreementNameRowTID().AgreementNameRowTestIds;
const AgreementNameSheet = (param)=>{
    let { currentValue, onCommit, label } = param;
    const { t } = useLocaleKeys();
    const { hideBottomSheet } = useOverlayContext();
    const [tempValue, setTempValue] = useState(currentValue);
    const handleSave = ()=>{
        if (tempValue !== currentValue) onCommit(tempValue);
        hideBottomSheet();
    };
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        contentClassName: s.sheetContent,
        footer: {
            primaryAction: {
                text: t.common.buttons.save(),
                testId: AgreementNameRowTestIds.MobileSheetSaveButton(),
                onClick: handleSave
            }
        },
        children: /*#__PURE__*/ _jsx(TextField, {
            testId: AgreementNameRowTestIds.NameInput(),
            label: label,
            value: tempValue,
            onChange: (e)=>setTempValue(e.target.value)
        })
    });
};
export const TriageAgreementNameRow = (param)=>{
    let { model, onModelChange } = param;
    const { t } = useLocaleKeys();
    const { pushBottomSheetPage } = useOverlayContext();
    const label = t.agreementImport.triageModal.agreementNameLabel();
    const openSheet = ()=>pushBottomSheetPage({
            content: /*#__PURE__*/ _jsx(AgreementNameSheet, {
                currentValue: model.agreementName(),
                onCommit: (value)=>onModelChange(model.setAgreementName(value)),
                label: label
            })
        });
    return /*#__PURE__*/ _jsx(TriageRow, {
        label: label,
        testId: AgreementNameRowTestIds.Root(),
        mobile: {
            body: model.agreementName(),
            onEdit: openSheet,
            editTestId: AgreementNameRowTestIds.MobileEditButton()
        },
        children: /*#__PURE__*/ _jsx(TriageFieldBox, {
            variant: {
                type: 'editableText',
                value: model.agreementName(),
                onChange: (value)=>onModelChange(model.setAgreementName(value)),
                testId: AgreementNameRowTestIds.NameInput()
            }
        })
    });
};
